import React, { useEffect, useState } from "react";
import * as Phosphor from "@phosphor-icons/react";
import { fetchRecommendations } from "@/lib/api";

const priorityTone = {
  high: { bg: "rgba(255,85,0,0.10)", fg: "#FF7A45", dot: "#FF5500", label: "Dringend" },
  medium: { bg: "#17130C", fg: "#9E6316", dot: "#FFC24B", label: "Empfohlen" },
  low: { bg: "rgba(0,250,154,0.12)", fg: "#00FA9A", dot: "#00FA9A", label: "Routine" },
};

const categoryIcon = {
  water: "Drop",
  plant: "Plant",
  forest: "Tree",
  market: "ChartLineUp",
};

/** Panel showing "Was ich heute tun soll" for a region. */
export default function RecommendationsPanel({ regionId, regionLabel, testid }) {
  const [recs, setRecs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      setLoading(true);
      try {
        const data = await fetchRecommendations(regionId);
        if (active) setRecs(data?.recommendations || []);
      } catch {
        if (active) setRecs([]);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, [regionId]);

  return (
    <div className="eid-card p-4 md:p-5" data-testid={testid}>
      <div className="flex items-baseline justify-between mb-3">
        <div>
          <div className="eid-label">Was ich heute tun sollte</div>
          <h3 className="text-lg font-medium tracking-tight mt-1">
            {regionLabel} · Handlungsempfehlungen
          </h3>
        </div>
        <div className="text-[11px] font-mono text-zinc-500">
          Automatisch abgeleitet · {recs.length} Einträge
        </div>
      </div>

      {loading ? (
        <div className="text-sm text-zinc-500">Berechne Empfehlungen…</div>
      ) : (
        <div className="space-y-2" data-testid={`${testid}-list`}>
          {recs.map((r) => {
            const tone = priorityTone[r.priority] || priorityTone.low;
            const IconComp = Phosphor[r.icon] || Phosphor[categoryIcon[r.category]] || Phosphor.Info;
            return (
              <div
                key={r.id}
                className="flex items-start gap-3 border border-white/10 rounded-sm p-3 bg-[#121212]"
                data-testid={`rec-${r.id}`}
                style={{ borderLeft: `3px solid ${tone.dot}` }}
              >
                <span
                  className="p-2 rounded-sm mt-0.5"
                  style={{ background: tone.bg, color: tone.fg }}
                >
                  <IconComp size={20} weight="regular" />
                </span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span
                      className="text-[10px] font-mono uppercase tracking-wider px-1.5 py-0.5 rounded-sm"
                      style={{ background: tone.bg, color: tone.fg }}
                    >
                      {tone.label}
                    </span>
                    <span className="font-medium text-sm">{r.title}</span>
                  </div>
                  <p className="text-sm text-zinc-400 mt-1">{r.reason}</p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
